import {createStore} from "redux";
import reducers from './Reducers';

export default createStore(reducers);